import React, { PropsWithChildren } from "react";
import styles from "./ErrorBlade.module.css";

export const WarningsBlade: React.FC<
  PropsWithChildren<{ environment: string; warnings?: string[] }>
> = ({ environment, warnings, children }) => {
  const allowedEnvironments = [
    "test",
    "test-preview",
    "sandbox",
    "sandbox-preview",
    "stage-live",
    "stage-preview",
    "preview",
  ];
  const hasWarnings = warnings && warnings.length > 0;

  // Always log warnings to console regardless of environment
  if (hasWarnings) {
    console.warn("Blade Rendering Warnings:\n", warnings.join("\n"));
  }

  const hasChildren = React.Children.count(children) > 0;
  // Only render the visual warning component in test/preview environments
  if (
    allowedEnvironments.includes(environment) &&
    (hasWarnings || hasChildren)
  ) {
    return (
      <div
        data-testid="error-blade"
        className={styles.warningWrapper}
        id="dev-all-warnings"
      >
        <a href="#dev-all-warnings" className={styles.anchor}>
          !
        </a>
        <h2 className={styles.heading}>Warnings</h2>
        {warnings?.map((warning, i) => (
          <pre key={i} className={styles.errorMessage}>
            - {warning}
          </pre>
        ))}
        {hasChildren && <pre>{children}</pre>}
      </div>
    );
  }
  return null;
};
